'use client';

import { useMemo } from 'react';
import type { ReachOutRequest, ReachOutResponse } from '@cabal/shared/domain/system/types.js';
import { useApi } from '@/contexts/api';
import { useActionHook } from '@/lib/query/use-action-hook';
import type { ActionResult } from '@/types/async-protocol';

export type ReachOutVars = ReachOutRequest;

export function useReachOut(): ActionResult<ReachOutVars, ReachOutResponse> {
  const api = useApi();
  const apiSystem = api.system;
  return useActionHook<ReachOutVars, ReachOutResponse>(
    useMemo(
      () => ({
        mutationFn: (body) => apiSystem.reachOut({ body }),
      }),
      [apiSystem],
    ),
  );
}
